@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/inputs' as *;

:host {
  display: block;
  @include default-css-variables;
  width: inherit;
}

.nylas-page-name {
  width: inherit;
  display: flex;
  flex-direction: column;
  margin: 1rem;
  border-radius: var(--nylas-border-radius-2x);
  border: 1px solid var(--nylas-base-200);
  text-align: left;

  .header {
    padding: 1rem;
    display: grid;
    grid-template-columns: 1fr auto;

    h3 {
      border-radius: var(--nylas-border-radius-2x);
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      color: var(--nylas-base-900);
      text-align: left;
    }

    p {
      display: flex;
      gap: 4px;
      align-items: center;
      margin: 0.25rem 0 0 0;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 20px;
      color: var(--nylas-base-600);
      text-align: left;

      .required-asterisk {
        color: var(--nylas-error);
      }
    }

    .drawer-toggle {
      display: flex;
      gap: 24px;
      align-items: center;

      .chevron {
        display: flex;
        align-self: center;
        cursor: pointer;

        &:hover,
        &:active {
          color: var(--nylas-primary);
        }

        &.open {
          transform: rotate(90deg);
        }

        &.closed {
          transform: rotate(270deg);
        }

        &.disabled {
          cursor: not-allowed;
          color: var(--nylas-base-300);

          &:hover {
            color: var(--nylas-base-300);
          }
        }
      }
    }
  }

  .nylas-page-name__body {
    display: grid;
    grid-template-columns: 1fr;
    background-color: var(--nylas-base-25);
    border-radius: 0 0 var(--nylas-border-radius-2x) var(--nylas-border-radius-2x);
    border-top: 1px solid var(--nylas-base-200);

    @media #{$mobile} {
      grid-template-columns: 1fr;
    }

    .nylas-page-name__section {
      padding: 1rem;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      color: var(--nylas-base-800);

      @media #{$mobile} {
        border: none;
      }

      .nylas-page-name__row {
        display: flex;
        align-items: center;
        gap: 1rem;

        label {
          display: flex;
          align-items: center;

          span.required {
            color: var(--nylas-error, #cc4841);
          }
        }

        p {
          margin: 0.25rem 0 0 0;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          color: var(--nylas-base-900);
        }

        .input-container {
          width: 100%;

          span.error-message {
            color: var(--nylas-error);
          }
        }
      }
    }
  }

  .nylas-page-name__input-wrapper {
    @include textfield;
    width: -moz-available;
    width: -webkit-fill-available;
    display: flex;
    flex-direction: row;
    gap: 0.125rem;
    border-radius: var(--nylas-border-radius-2x);
    z-index: 1;

    &.error {
      border: 1px solid var(--nylas-error);
    }

    input-component::part(ic__input) {
      outline: none;
      border: none;
      width: 100%;
      font-size: 16px;
      height: auto;
      padding-left: 0px;
    }
  }
}
